module.exports = __webpack_public_path__ + "static/media/c-a1.a8feb997.svg";